const enum MediaQuery {
  maxXs = '(max-width: 576px)',
  maxSm = '(max-width: 768px)',
  maxMd = '(max-width: 992px)',
  maxLg = '(max-width: 1200px)',
  maxXl = '(min-width: 1201px)',
}

export default MediaQuery;
